"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
function createMethodKeyCache() {
    var methodKeyMap = new WeakMap();
    function setMethodKey(method, methodKey) {
        methodKeyMap.set(method, methodKey);
    }
    // allows us to get a unique string key that identifies the api and method for storage in redux state
    function getMethodKey(method) {
        var methodKey = methodKeyMap.get(method);
        // If we can't find a string for this method (like a custom method someone didn't register)
        // generate a guid for it and add it to our map
        if (!methodKey) {
            methodKey = utils_1.uniqueGUID();
            setMethodKey(method, methodKey);
        }
        return typeof methodKey === "string" ? methodKey : methodKey();
    }
    return { setMethodKey: setMethodKey, getMethodKey: getMethodKey };
}
exports.default = createMethodKeyCache;
//# sourceMappingURL=methodKeyCache.js.map